export const dashboard = {
  // Dashboard main
  "dashboard.title": "Dashboard",
  "dashboard.welcome": "Welcome",
  "dashboard.overview": "Overview",
  
  // Stats cards
  "stats.total_views": "Total Views",
  "stats.total_contacts": "Total Contacts",
  "stats.total_reviews": "Total Reviews",
  "stats.avg_rating": "Average Rating",
  "stats.total_products": "Total Products",
  "stats.active_products": "Active Products",
  "stats.monthly_revenue": "Monthly Revenue",
  
  // Navigation tabs
  "tab.overview": "Overview",
  "tab.profile": "Profile",
  "tab.products": "Products",
  "tab.reviews": "Reviews",
  "tab.analytics": "Analytics",
  "tab.subscription": "Subscription",
  "tab.settings": "Settings",
  "tab.team": "Team",
  "tab.purchase_requests": "Purchase Requests",
  "tab.messages": "Messages",
  "tab.galerie": "Gallery",
  "tab.verification": "Verification",
  
  // Profile section
  "profile.title": "Profile Information",
  "profile.business_name": "Business Name",
  "profile.description": "Description",
  "profile.category": "Category",
  "profile.phone": "Phone",
  "profile.email": "Email",
  "profile.website": "Website",
  "profile.address": "Address",
  "profile.city": "City",
  "profile.state": "State",
  "profile.business_hours": "Business Hours",
  "profile.update": "Update Profile",
  
  // Products section
  "products.title": "Product Management",
  "products.add": "Add Product",
  "products.edit": "Edit Product",
  "products.delete": "Delete Product",
  "products.name": "Product Name",
  "products.price": "Price",
  "products.stock": "Stock",
  "products.category": "Category",
  "products.description": "Description",
  "products.images": "Images",
  "products.image": "Image",
  "products.status": "Status",
  "products.in_development": "Feature under development",
  
  // Subscription section
  "subscription.title": "Subscription Plan",
  "subscription.current_plan": "Current Plan",
  "subscription.upgrade": "Upgrade",
  "subscription.features": "Features",
  "subscription.billing": "Billing",
  "subscription.expires": "Expires on {{date}}",
  "subscription.select_plan": "Choose this plan",
  "subscription.current_badge": "Current plan",
  "subscription.plan_free_price": "Free",
  "subscription.plan_basic_price": "25,000 XOF / 30 days",
  "subscription.plan_premium_price": "200,000 XOF / 365 days",
  "subscription.premium_includes_featured": "Showcase included",
  "subscription.featured_title": "Showcase",
  "subscription.featured_desc": "Your profile appears at the top of search results and categories for 30 days.",
  "subscription.featured_price": "50,000 XOF / 30 days",
  "subscription.featured_cta": "Activate Showcase",
  "subscription.featured_active": "Showcase active until {{date}}",
  
  // Plans
  "plan.free": "Free",
  "plan.basic": "Basic",
  "plan.premium": "Premium",
  "plan.free_desc": "Perfect to get started",
  "plan.basic_desc": "For small businesses",
  "plan.premium_desc": "For large businesses",
  
  // Plan features
  "plan.free_max_products": "5 products max",
  "plan.basic_max_products": "50 products",
  "plan.unlimited_products": "Unlimited products",
  "plan.basic_support": "Basic support",
  "plan.priority_support": "Priority support",
  "plan.support_247": "24/7 support",
  "plan.simple_profile": "Simple profile",
  "plan.basic_analytics": "Basic analytics",
  "plan.advanced_analytics": "Advanced analytics",
  "plan.verified_badge": "Verified badge",
  "plan.priority_promotion": "Priority promotion",
  
  // Features
  "feature.products_limit": "products maximum",
  "feature.photos_limit": "photos per product",
  "feature.analytics": "Advanced Analytics",
  "feature.priority_support": "Priority Support",
  "feature.custom_domain": "Custom Domain",
  "feature.unlimited": "Unlimited",
  
  // Gallery section
  "gallery.title": "Gallery Management",
  "gallery.subtitle": "Manage your photos to showcase your services to customers.",
  "gallery.edit": "Edit",
  "gallery.cancel": "Cancel",
  "gallery.save": "Save",
  "gallery.saving": "Saving...",
  "gallery.photo_limit": "Photos: {{count}} / {{max}} (subscription limit {{plan}})",
  "gallery.add_image_url": "Add Image URL",
  "gallery.placeholder_url": "https://example.com/image.jpg",
  "gallery.add": "Add",
  "gallery.no_photos": "No photos in your gallery",
  "gallery.add_photos": "Add photos",

  // Upgrade messages
  "dashboard.my_business": "My Business",
  "dashboard.toggle_sidebar": "Toggle sidebar",
  "dashboard.expand_sidebar": "Expand sidebar",
  "dashboard.collapse_sidebar": "Collapse sidebar",
  "dashboard.start_tour": "Start guided tour",
  "dashboard.manage_business": "Manage your business and information",
  "dashboard.orders": "Orders",
  "dashboard.monthly_revenue": "Monthly Revenue",
  "dashboard.save_error": "Error saving",
  "dashboard.delete_product": "Delete Product",
  "dashboard.delete_product_confirm": "Are you sure you want to delete \"{{name}}\"? This action is irreversible.",
  "dashboard.delete_review": "Delete Review",
  "dashboard.delete_review_confirm": "Are you sure you want to delete {{name}}'s review?",
  "dashboard.client": "Client",
  "dashboard.gallery": "Gallery",
  "dashboard.reviews": "Reviews",
  "dashboard.verification": "Verification",
  "dashboard.analytics": "Analytics",
  "dashboard.subscription": "Subscription",
  "dashboard.team": "Team",
  "dashboard.purchase_requests": "Purchase Requests",
  "dashboard.my_purchase_requests": "My purchase requests",
  "dashboard.manage_purchase_requests_desc": "Track your purchase requests and the quotes received from suppliers.",
  "dashboard.no_purchase_requests": "You don't have any purchase requests yet",
  "dashboard.create_request_from_home": "Publish a request from the “Purchase Request” page to receive supplier quotes.",
  "dashboard.confirm_delete": "Confirm deletion?",
  "dashboard.business_profile": "Business Profile",

  // Error messages  
  "dashboard.errors.add_product": "Unknown error when adding product",
  "dashboard.errors.update_product": "Unknown error when updating product",
  "dashboard.errors.delete_product": "Unknown error when deleting product",
  "dashboard.errors.update_review": "Error updating review",
  "dashboard.errors.delete_review": "Error deleting review",

  // Success messages
  "dashboard.success.review_updated": "Review updated",
  "dashboard.success.review_deleted": "Review deleted",

  // Coming soon messages
  "dashboard.coming_soon.title": "Feature under development",
  "dashboard.coming_soon.message": "This feature is not yet available but will be coming soon.",
  "dashboard.coming_soon.analytics": "Advanced analytics will be available soon.",
  "dashboard.coming_soon.team": "Team management will be available soon.",
  "dashboard.coming_soon.subscription": "Subscription management will be available soon.",
  
  // Tour messages
  "dashboard.tour.skip": "Skip",
  "dashboard.tour.previous": "Previous",
  "dashboard.tour.next": "Next",
  "dashboard.tour.finish": "Finish",
  "dashboard.tour.welcome.title": "Welcome to your dashboard",
  "dashboard.tour.welcome.content": "Discover the features of your dashboard to manage your business.",
  "dashboard.tour.sidebar.title": "Navigation",
  "dashboard.tour.sidebar.content": "Use the sidebar to access different sections of your dashboard.",
  "dashboard.tour.overview.title": "Overview",
  "dashboard.tour.overview.content": "View key statistics of your business at a glance.",
  "dashboard.tour.profile.title": "Profile",
  "dashboard.tour.profile.content": "Manage your business information and contact details.",
  "dashboard.tour.products.title": "Products",
  "dashboard.tour.products.content": "Add, edit or delete your products and services.",
  "dashboard.tour.reviews.title": "Reviews",
  "dashboard.tour.reviews.content": "View and respond to customer reviews.",
  "dashboard.tour.analytics.title": "Analytics",
  "dashboard.tour.analytics.content": "Analyze your business performance with detailed charts.",
  "dashboard.tour.subscription.title": "Subscription",
  "dashboard.tour.subscription.content": "Manage your subscription and discover premium features.",
  "dashboard.tour.settings.title": "Settings",
  "dashboard.tour.settings.content": "Configure your account and business settings.",
  "dashboard.tour.team.title": "Team",
  "dashboard.tour.team.content": "Manage your team members and their permissions.",
  "dashboard.tour.notifications.title": "Notifications",
  "dashboard.tour.notifications.content": "Stay informed about important business activities.",
  "dashboard.tour.complete.title": "Guided tour completed",
  "dashboard.tour.complete.content": "You have completed the guided tour. Explore your dashboard and feel free to return here if you have any questions.",

  // Loading and messages
  "loading.title": "Loading dashboard...",
  "loading.timeout_title": "Loading is taking longer than expected",
  "loading.timeout_message": "Please wait or try again. If the problem persists, check your internet connection.",
  "loading.retry": "Retry",

  // Success messages for products
  "dashboard.success.product_added": "Product added successfully",
  "dashboard.success.product_updated": "Product updated",
  "dashboard.success.product_deleted": "Product deleted"
};

export default dashboard;